module.exports = __webpack_public_path__ + "static/media/fastSpiralTitle.0b78d215.jpg";